import {Component} from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";
import {OrganizationService} from "../services/organization.service";
import {Organization} from "../models/organization";
import {Event} from "../models/event";
import {EventService} from "../services/event.service";
import {firstValueFrom, Observable} from "rxjs";
import {User} from "../models/user";

@Component({
    selector: 'app-my-organization',
    templateUrl: './my-organization.component.html',
    styleUrls: ['./my-organization.component.css'],
    standalone: false
})
export class MyOrganizationComponent {
  user!: User;
  organization!: Organization;
  eventCounter: number = 0;
  events!: Observable<Event[]>;
  creationDate!: Date;

  constructor(
    public authService: AuthenticationService,
    public orgService: OrganizationService,
    public eventService: EventService,
  ) { }

  async ngOnInit() {
    this.user = await this.authService.getUser();
    this.organization = await firstValueFrom(this.orgService.getOrganizationByRef(this.user.organization));
    this.events = this.eventService.getEventsByOrganization(this.user.organization);

    this.events.subscribe(data => {
      this.eventCounter = data.length;
    });
  }

}
